import { render } from "./POSPage.vue?vue&type=template&id=71aae379&scoped=true"
import script from "./POSPage.vue?vue&type=script&lang=js"
export * from "./POSPage.vue?vue&type=script&lang=js"

import "./POSPage.vue?vue&type=style&index=0&id=71aae379&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71aae379"]])

export default __exports__